angular.module('dialogs')
    .factory('$dialogs',
    [
        '$modal', function($modal) {

            var $dialogs = {};

            $dialogs.confirm = function(header, msg, onYesClick) {
                return $modal.open({
                    templateUrl: '/dialogs/confirmDialog.html',
                    controller: 'confirmDialogCtrl',
                    resolve: {
                        header: function() { return angular.copy(header); },
                        msg: function() { return angular.copy(msg); },
                        onYesClick: function() { return angular.copy(onYesClick); }
                    }
                });
            };

            $dialogs.EventInfo = function(sportCode) {
                return $modal.open({
                    templateUrl: '/dialogs/EventInfoDialog.html',
                    controller: 'EventInfoDialogCtrl',
                    resolve: {
                        sportCode: function() { return angular.copy(sportCode); }
                    }
                });
            };

            $dialogs.DrawApproval = function() {
                return $modal.open({
                    templateUrl: '/dialogs/DrawApprovalDialog.html',
                    controller: 'DrawApprovalDialogCtrl'
                });
            };

            $dialogs.Information = function(eventId, gameId) {
                return $modal.open({
                    templateUrl: '/dialogs/InfomationDialog.html',
                    controller: 'InformationDialogCtrl',
                    resolve: {
                        eventId: function() { return angular.copy(eventId); },
                        gameId: function() { return angular.copy(gameId); }
                    }
                });
            };

            $dialogs.ReleaseTime = function() {
                return $modal.open({
                    templateUrl: "/dialogs/ReleaseTimeDialog.html",
                    controller: "ReleaseTimeDialogCtrl"
                });
            };

            $dialogs.PreDrawCertificate = function() {
                return $modal.open({
                    templateUrl: '/dialogs/PreDrawCertificateDialog.html',
                    controller: 'PreDrawCertificateDialogCtrl'
                });
            };

            $dialogs.confirmResults = function(header, msg, hasBonusNumber) {
                return $modal.open({
                    templateUrl: '/dialogs/confirmResultsDialog.html?v=20200820',
                    controller: 'confirmResultsDialogCtrl',
                    resolve: {
                        header: function() { return angular.copy(header); },
                        msg: function () { return angular.copy(msg); },
                        hasBonusNumber: function () { return angular.copy(hasBonusNumber); }
                    }
                });
            };

            return $dialogs;
        }
    ]);
